import React from 'react';

export const CONTENT_ICON_OPTIONS = [
  { id: 'corazon', label: 'Corazón' },
  { id: 'avion', label: 'Avión' },
  { id: 'mundo', label: 'Mundo' },
  { id: 'maleta', label: 'Maleta' },
  { id: 'mapa', label: 'Mapa' },
  { id: 'ubicacion', label: 'Ubicación' },
  { id: 'personas', label: 'Personas' },
  { id: 'estrella', label: 'Estrella' },
  { id: 'check', label: 'Check' },
  { id: 'camara', label: 'Cámara' },
  { id: 'proteccion', label: 'Protección' },
  { id: 'asistencia', label: 'Asistencia' },
] as const;

const SHAPES: Record<string, React.ReactNode> = {
  corazon: (
    <path d='M12 20s-7-4.4-9.2-8.7A5.2 5.2 0 0 1 12 6.3a5.2 5.2 0 0 1 9.2 5C19 15.6 12 20 12 20z' />
  ),
  avion: (
    <path d='M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z' />
  ),
  mundo: (
    <>
      <circle cx='12' cy='12' r='9' />
      <path d='M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z' />
    </>
  ),
  maleta: (
    <>
      <rect height='13' rx='2' width='18' x='3' y='7' />
      <path d='M8.5 7V5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2M3 12h18' />
    </>
  ),
  mapa: (
    <>
      <path d='M9 4L3 6.5v13.5l6-2.5 6 2.5 6-2.5V4l-6 2.5z' />
      <path d='M9 4v13.5M15 6.5V20' />
    </>
  ),
  ubicacion: (
    <>
      <path d='M12 21s-7-6.2-7-11.2a7 7 0 0 1 14 0C19 14.8 12 21 12 21z' />
      <circle cx='12' cy='9.8' r='2.6' />
    </>
  ),
  personas: (
    <>
      <circle cx='9' cy='8' r='3.4' />
      <path d='M2.5 20a6.5 6.5 0 0 1 13 0' />
      <circle cx='17' cy='9' r='2.5' />
      <path d='M16 14.2a5 5 0 0 1 5.5 4.8' />
    </>
  ),
  estrella: <path d='M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9z' />,
  check: (
    <>
      <circle cx='12' cy='12' r='9' />
      <path d='M8 12.3l2.8 2.8L16.5 9' />
    </>
  ),
  camara: (
    <>
      <path d='M4 8h3.2l1.8-2.7h6l1.8 2.7H20v11H4z' />
      <circle cx='12' cy='13.2' r='3.4' />
    </>
  ),
  proteccion: (
    <>
      <path d='M12 3l8 3v6c0 4.8-3.4 7.9-8 9-4.6-1.1-8-4.2-8-9V6z' />
      <path d='M8.8 12l2.2 2.2 4.2-4.4' />
    </>
  ),
  asistencia: (
    <>
      <path d='M4 14v-2a8 8 0 0 1 16 0v2' />
      <rect height='6' rx='1.2' width='4' x='3' y='14' />
      <rect height='6' rx='1.2' width='4' x='17' y='14' />
      <path d='M19 20c0 1-2 1.5-4 1.5' />
    </>
  ),
};

export function ContentIcon({ id }: { id: string }) {
  return (
    <svg aria-hidden='true' viewBox='0 0 24 24'>
      {SHAPES[id] || SHAPES.estrella}
    </svg>
  );
}
